import { SagaIterator } from 'redux-saga';
import { call, all, put, takeLatest } from 'redux-saga/effects';
import i18next from 'i18next';
import { PapiDaSharedEmailUnsubscribe } from '@wix/da-papi-types';
import { putErrorNotification } from '@wix/da-shared-react/pkg/utils/saga';
import { XhrResponse, isApiError, requestPuppy } from '@wix/da-http-client';
import { unsubscribe, unsubscribeSuccess } from '../actions/emailUnsubscribe';

function* unsubscribeSaga(action: ReturnType<typeof unsubscribe>) {
  const { type, email, token } = action.payload || {};

  const response: XhrResponse<PapiDaSharedEmailUnsubscribe> = yield call(
    requestPuppy,
    {
      method: 'post',
      url: 'email/unsubscribe',
      data: {
        type: type === 'marketing' ? 'news' : 'activity',
        email,
        security_token: token,
      },
    },
    () => ({ success: true })
  );

  if (!response || isApiError(response) || !response.success) {
    const errorDescription =
      (response || ({} as any)).errorDescription || 'Request failed';
    yield putErrorNotification(
      i18next.t('emailUnsubscribe.saga.error', { errorDescription })
    );
    return;
  }

  yield put(unsubscribeSuccess());
}

export default function* saga(): SagaIterator {
  yield all([takeLatest(unsubscribe, unsubscribeSaga)]);
}
